<template>
  <el-container class="page-x" direction="vertical">
    <div v-if="reportSource === 'AIKANG'" class="cont-x" ref="contX">
      <el-tabs v-model="activeTab" @tab-click="toChangeTab">
        <el-tab-pane
          v-auth="'sa_exam_detail_original'"
          label="体检报告原件"
          name="first"
        >
          <div class="cont-x-iframe" :style="`height: ${contHeight - 40}px`">
            <iframe
              class="origin-x"
              :src="pdfUrl"
              :height="contHeight - 40"
              frameborder="0"
            ></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-auth="'sa_exam_detail_data'"
          label="解析后数据"
          name="second"
        >
          <div>
            <div class="table-x" ref="tableBox">
              <el-table :data="tableData" border height="800" class="mb20">
                <el-table-column
                  prop="indexName"
                  align="center"
                  label="指标名称"
                >
                </el-table-column>
                <el-table-column
                  prop="normalRange"
                  align="center"
                  label="指标值"
                >
                </el-table-column>
                <el-table-column
                  prop="indexResultUnit"
                  align="center"
                  label="单位"
                >
                </el-table-column>
                <el-table-column
                  prop="indexResultValue"
                  align="center"
                  label="结果"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="reportSource === 'MJK'" class="cont-x cont-x-iframe" ref="contX">
      <el-tabs v-model="activeMJKTab" @tab-click="toChangeMJKTab">
        <el-tab-pane
          v-auth="'sa_exam_detail_original'"
          label="体检报告"
          name="MJKReport"
        >
          <div class="cont-x-iframe" :style="`height: ${contHeight - 40}px`">
            <iframe
              class="origin-x"
              :src="miaoReportUrl"
              :height="contHeight"
              frameborder="0"
            ></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-auth="'sa_exam_detail_data'"
          label="异常数据"
          name="MJKData"
        >
          <div>
            <div class="table-x" ref="tableBox">
              <el-table :data="dataList" border class="mb20">
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="indexName"
                  align="center"
                  label="项目名称"
                >
                </el-table-column>
                <el-table-column
                  prop="indexResultValue"
                  align="center"
                  label="值"
                >
                </el-table-column>
                <el-table-column
                  prop="indexResultUnit"
                  align="center"
                  label="单位"
                >
                </el-table-column>
                <el-table-column
                  prop="normalRange"
                  align="center"
                  label="参考范围"
                >
                </el-table-column>
              </el-table>
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableErrorData.length"
                background
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-button size="mini" @click="$router.go(-1)" class="back">返回</el-button>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      reportSource: "",
      activeTab: "first",
      activeMJKTab: "MJKReport",
      //分页
      currentPage: 1,
      pageSize: 10,
      bookingId: "", // 预约Id
      orderNo: "", // 订单号
      pdfUrl: "",
      contHeight: "",
      miaoReportUrl: "",
      tableData: [],
      tableErrorData: [],
    };
  },
  created() {
    this.$root.breadList = [];
    let pathSource = this.$route.query.pathSource || "";
    if (pathSource) {
      let arr = pathSource.split(",");
      arr.forEach((item) => {
        this.$root.breadList.push({
          name: item,
          link: "",
        });
      });
    } else {
      this.$root.breadList = [
        { name: "体检报告", link: "" },
        { name: "体检报告查询", link: "" },
        { name: "报告详情", link: "" },
      ];
    }
    this.reportSource = this.$route.query.reportSource || "";
    this.bookingId = this.$route.query.id || "";
  },
  computed: {
    dataList() {
      return this.tableErrorData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
  mounted() {
    // 处理iframe高度问题
    this.$nextTick(() => {
      this.contHeight = this.$refs.contX.offsetHeight;
    });
    // 节流函数
    var onresizeChange = onresize(() => {
      this.contHeight = this.$refs.contX.offsetHeight;
    });
    window.onresize = () => {
      onresizeChange();
    };

    if (this.reportSource === "AIKANG") {
      this.getSource();
      this.getParse();
    } else {
      this.getErrorData();
      this.miaoReportUrl = `${this.getApiUrl(
        "examReportDetailOcr"
      )}?bookingId=${this.bookingId}&type=${this.$route.query.source}&token=${
        this.$root.$data.token
      }`;
    }
  },
  beforeDestroy() {
    // 清除监听
    window.onresize = () => {};
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    getSource() {
      this.pdfUrl = `${this.getApiUrl("examReportDetailOriginal")}?bookingId=${
        this.bookingId
      }&type=${this.$route.query.source}&token=${this.$root.$data.token}`;
    },
    getParse() {
      let apiName = "examReportDetailData";
      let data = {
        bookingId: Number(this.bookingId),
        type: this.$route.query.source,
      };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { code, msg, data } = res;
          console.log(data);
          if (code === 1) {
            this.tableData = data.data || data;
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getErrorData() {
      let apiName = "examReportException";
      let data = {
        bookingId: Number(this.bookingId),
        type: this.$route.query.source,
      };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let arr = [];
          let data = res.data.itemList || [];
          if (res.code === 1) {
            data.forEach((item) => {
              let content = item.indexList.filter((val) => {
                return val.indexResultType == 0; // 筛选异常数据
              });
              arr.push(...content);
            });
            console.log(arr);
            this.tableErrorData = arr || [];
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toChangeTab() {
      if (this.activeTab === "first") {
        // 报告原件
      } else if (this.activeTab === "second") {
        // 解析数据
      }
    },
    toChangeMJKTab() {},
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "bodyReportQuery") {
      to.meta.keepAlive = true;
    }
    next(true);
  },
};
/**
 * 节流函数
 */
function onresize(cb) {
  var cache = false;
  return () => {
    if (cache) clearTimeout(cache);
    cache = setTimeout(() => {
      cb();
    }, 500);
  };
}
</script>
<style type="text/scss" lang="scss" scoped>
.page-x {
  position: relative;
  .back {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.cont-x {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cont-x ::v-deep .el-tabs__header {
  flex-shrink: 0;
}
.cont-x ::v-deep .el-tabs__content {
  flex: 1;
  // background: yellow;
}

.origin-x {
  width: 100%;
}
</style>
